import Vue from 'vue'
import Router from 'vue-router'

import Login from '../Security/Login.vue'
import Logout from '../Security/Logout.vue'
import Guides from '../Guides/Guides.vue'
import PasswordChange from '../Security/PasswordChange.vue'
import MyScheduleView from '../Education/MyScheduleView.vue'
import ExamRegister from '../Exams/ExamRegister.vue'
import ExamUnregister from '../Exams/ExamUnregister.vue'
import PresenceAndExamResults from '../Exams/PresenceAndExamResults.vue'

import Downloads from '../SeminarTask/Downloads.vue'
import SeminarTaskUpload from '../SeminarTask/SeminarTaskUpload.vue'
import ProgramDeadline from '../Education/ProgramDeadline.vue'
import MyDigitalCertificate from '../Education/MyDigitalCertificate.vue'
import MyEducationView from '../Education/MyEducationView.vue';



import Page404 from './Page404.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  //history: false,
  //root: window.VueRouterUrl,
  routes: [
    {
      path: '/Portal/Security/Login',
      name: 'menu_login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/Portal/Security/Logout',
      name: 'Logout',
      component: Logout,
      meta: { requiresAuth: true }
    },
    {
      path: '/Portal/Guides',
      name: 'Guides',
      component: Guides,
      meta: { requiresAuth: true }
    },
    {
      path: '/Portal/Security/PasswordChange',
      name: 'menu_password_change',
      component: PasswordChange,
      meta: { requiresAuth: true },
    },
    {
      path: '/',
      name: 'menu_my_schedule',
      component: MyScheduleView,
      meta: { requiresAuth: true },
    },
    {
      path: '/Portal/Education/MyEducation',
      name: 'menu_my_education',
      component: MyEducationView,
      meta: { requiresAuth: true },
    },
    {
      path: '/Portal/ExamRegister',
      name: 'menu_exam_register',
      component: ExamRegister,
      meta: { requiresAuth: true },
    },
    {
      path: '/Portal/ExamUnregister',
      name: 'menu_exam_unregister',
      component: ExamUnregister,
      meta: { requiresAuth: true }
    },
    {
      path: '/Portal/Docs/Download',
      name: 'menu_seminar_task_download',
      component: Downloads,
      meta: { requiresAuth: true }
    },
    {
      path: '/Portal/Exams/ExamResults',
      name: 'menu_presence_exam_results',
      component: PresenceAndExamResults,
      meta: { requiresAuth: true }
    },
    {
      path: '/Portal/Seminar/Upload',
      name: 'menu_seminar_task_upload',
      component: SeminarTaskUpload,
      meta: { requiresAuth: true }
    },
    {
      path: '/Portal/Education/Deadline',
      name: 'menu_education_deadline',
      component: ProgramDeadline,
      meta: { requiresAuth: true }
    },
    {
      path: '/Portal/Education/MyDigitalCertificate',
      name: 'menu_digital_cerficates',
      component: MyDigitalCertificate,
      meta: { requiresAuth: true }
    },
    {
      path: '*',
      name: '404',
      component: Page404,
      meta: { requiresAuth: false }
    }
    
    //{
    //  path: '/about',
    //  name: 'about',
    //  component: About
    //  // route level code-splitting
    //  // this generates a separate chunk (about.[hash].js) for this route
    //  // which is lazy-loaded when the route is visited.
    //  //component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    //}
  ]
})



// WEBPACK FOOTER //
// ./VueSrc/Common/router.js